import type { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export type Size = 'sm' | 'lg' | 'block'

export type Variation =
  | 'default'
  | 'light'
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'info'
  | 'success'
  | 'danger'
  | 'warning'
  | 'custom'

export enum VariationTypes {
  DEFAULT = 'default',
  LIGHT = 'light',
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export type ButtonProps = Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    active?: boolean
    disabled?: boolean
    icon?: IconDefinition
    loading?: boolean
    size?: Size
    variation?: Variation
  },
  'ref'
>
